import { getQueryParams, updateURLParams, getParamsWithValue } from '@/infrastructure/Utils'
import { offerFilters } from '@/infrastructure/Configuration'

const nextPageSuccess = (state, payload) => ({
  ...payload,
  results: [...(state.offers.results || []), ...payload.results]
})
export default {
  updateOffersSuccess(state, payload) {
    let urlParams = getQueryParams(window.location.search)
    urlParams = getParamsWithValue(urlParams)
    urlParams = Object.keys(urlParams).reduce((acc, param) => {
      return !offerFilters.includes(param) ? { ...acc, [param]: urlParams[param] } : acc
    }, {})
    updateURLParams(Object.assign(urlParams, payload.filter.asUrlParams()))
    state.isSeeAllFilter = false
    state.isSeeAllFilterEurope = false
    state.offers = payload
    sessionStorage.setItem('filter', JSON.stringify(payload.filter))
  },

  nextPageSuccess(state, payload) {
    state.offers = nextPageSuccess(state, payload)
  },

  updateSessionStorage(_state, payload) {
    sessionStorage.setItem('filter', JSON.stringify(payload.filter))
  },

  updateOffersSuccessRevamp(state, payload) {
    state.slides = payload
    // sessionStorage.setItem('filter', JSON.stringify(payload.filter))
  },

  updateRegionsSuccess(state, payload) {
    state.regions = payload
  },

  updateCountriesAndCitiesSuccess(state, payload) {
    state.countriesWithCities = payload
  },
  updateSeeAllFilter(state, payload) {
    state.isSeeAllFilter = payload
  },
  updateSeeAllEurope(state, payload) {
    state.isSeeAllFilterEurope = payload
  },
  updateEmptySliders(state, payload) {
    state.emptySliders = payload
  },
  setRegisteredOfferCodes(state, payload) {
    state.registeredOfferCodes = payload
  },
  setPlace(state, place) {
    state.locationOrRegion = place
  }
}
